/* eslint-disable prefer-destructuring */
const envObj = process.env;
export const isGAMMA = envObj.NODE_ENV === 'gamma';
export const CURRENT_NODE_ENV = envObj.NODE_ENV;
export const POSTHOG_API_KEY = envObj.POSTHOG_API_KEY;
export const POSTHOG_API_HOST = envObj.POSTHOG_API_HOST;
